import { render, staticRenderFns } from "./sys-account.vue?vue&type=template&id=28d9136b&scoped=true"
import script from "./sys-account.vue?vue&type=script&lang=js"
export * from "./sys-account.vue?vue&type=script&lang=js"
import style0 from "./sys-account.vue?vue&type=style&index=0&id=28d9136b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d9136b",
  null
  
)

export default component.exports